// ================================================================
// Node Component — رندر یه node منفرد
// ================================================================

import { t } from '../../i18n/index.js';
import { icon, escapeHtml } from '../../utils/dom.js';
import { nodeRegistry } from '../../nodes/registry.js';
import { state } from '../../core/state.js';
import { events, EVENTS } from '../../core/events.js';
import { makeDraggable } from '../../utils/drag.js';

export function createNodeElement(nodeData, canvasEl) {
  const def = nodeRegistry.get(nodeData.type);
  if (!def) {
    console.error(`Unknown node type: ${nodeData.type}`);
    return null;
  }

  const el = document.createElement('div');
  el.className = 'node';
  el.dataset.type = nodeData.type;
  el.dataset.id = nodeData.id;
  el.style.left = nodeData.x + 'px';
  el.style.top = nodeData.y + 'px';

  el.innerHTML = `
    <div class="node-circle" style="background: ${def.colorGradient || def.color}">
      <span class="material-symbols-rounded node-icon" style="color: ${def.iconColor || 'white'}">${def.icon}</span>
      <div class="node-badge">1</div>
      <div class="node-clock">
        ${icon('schedule', 16)}
      </div>
      <div class="node-port-out" title="Verbinden"></div>
      <div class="node-plus" title="Add next">
        ${icon('add', 16)}
      </div>
    </div>
    <div class="node-label">
      <div class="node-title">
        ${escapeHtml(t(def.nameKey))}
        <span class="node-counter">${nodeData.id}</span>
      </div>
      <div class="node-subtitle">${escapeHtml(t(def.subtitleKey))}</div>
    </div>
  `;

  attachDrag(el, nodeData, canvasEl);
  attachClickAndPlus(el, nodeData);
  attachConnectPort(el, nodeData);

  return el;
}

function attachDrag(el, nodeData, canvasEl) {
  const handle = el.querySelector('.node-circle');
  let origX = 0;
  let origY = 0;

  makeDraggable(handle, {
    onStart: () => {
      origX = nodeData.x;
      origY = nodeData.y;
      state.wasDragged = false;
    },
    onMove: (dx, dy) => {
      const rect = canvasEl.getBoundingClientRect();
      const newX = Math.max(0, Math.min(rect.width - 100, origX + dx));
      const newY = Math.max(60, Math.min(rect.height - 140, origY + dy));

      el.classList.add('dragging');
      el.style.left = newX + 'px';
      el.style.top = newY + 'px';

      nodeData.x = newX;
      nodeData.y = newY;
      events.emit(EVENTS.NODE_MOVED, nodeData);
    },
    onEnd: (wasDragged) => {
      el.classList.remove('dragging');
      state.wasDragged = wasDragged;
      if (wasDragged) {
        state.moveNode(nodeData.id, nodeData.x, nodeData.y);
      }
    }
  });
}

function attachClickAndPlus(el, nodeData) {
  const circle = el.querySelector('.node-circle');
  const plus = el.querySelector('.node-plus');
  const def = nodeRegistry.get(nodeData.type);

  circle.addEventListener('click', (e) => {
    if (e.target.closest('.node-plus')) return;
    if (e.target.closest('.node-port-out')) return;
    if (state.wasDragged) {
      state.wasDragged = false;
      return;
    }

    if (def?.clickAction === 'openPicker') {
      events.emit(EVENTS.MODAL_OPEN_PICKER, { fromNodeId: nodeData.id });
    } else {
      events.emit(EVENTS.MODAL_OPEN_SETTINGS, { nodeId: nodeData.id });
    }
  });

  plus.addEventListener('click', (e) => {
    e.stopPropagation();
    events.emit(EVENTS.MODAL_OPEN_PICKER, { fromNodeId: nodeData.id });
  });

  el.addEventListener('contextmenu', (e) => {
    e.preventDefault();
    events.emit(EVENTS.CONTEXT_MENU_OPEN, {
      nodeId: nodeData.id,
      x: e.clientX,
      y: e.clientY
    });
  });
}

// نقطه‌ی خروجی → شروع کشیدن اتصال
function attachConnectPort(el, nodeData) {
  const port = el.querySelector('.node-port-out');
  if (!port) return;

  port.addEventListener('mousedown', (e) => {
    e.preventDefault();
    e.stopPropagation();
    events.emit(EVENTS.CONNECT_DRAG_START, {
      fromId: nodeData.id,
      clientX: e.clientX,
      clientY: e.clientY
    });
  });
}
